// Roupas. GABARITO da Onda 0: 'camiseta' (a primeira) mostra o padrão; as demais seguem a
// mesma forma: 16×8 no tronco, só colunas 4–11 pintadas.
//
// A roupa é uma sobreposição 16×8 no tronco e só pinta as colunas 4–11 (os braços, fora
// disso, já vêm na cor 'shirt' do corpo). Detalhes que valem a pena: gola, botões,
// bolso, zíper, gravata, barra. Paleta com slots: c/l/d = shirt2/3/1, x = shirt0,
// a/A = acc1/acc2 (detalhe numa segunda cor, ex.: gravata), w = white3, S = skin2,
// g = gold2 (botão), M = metal3 (zíper). `legs` (16×6) cobre a calça: saia, vestido,
// macacão, jaleco.

import { sprite } from '../pix.js';
import type { OverlayDef } from '../types.js';

const CLOTH = { c: 'shirt2', l: 'shirt3', d: 'shirt1', x: 'shirt0', a: 'acc1', A: 'acc2', w: 'white3', S: 'skin2', g: 'gold2', M: 'metal3' };

export const OUTFITS: readonly OverlayDef[] = [
  {
    id: 'camiseta',
    name: 'Camiseta',
    anchor: 'torso',
    frames: {
      down: sprite(
        [
          '......xSSx......',
          '.......xx.......',
          '................',
          '................',
          '................',
          '.....d....d.....',
          '....dddddddd....',
          '................',
        ],
        CLOTH,
      ),
      up: sprite(
        [
          '......xxxx......',
          '................',
          '................',
          '................',
          '................',
          '................',
          '....dddddddd....',
          '................',
        ],
        CLOTH,
      ),
      left: sprite(
        [
          '.....xSx........',
          '................',
          '................',
          '................',
          '................',
          '................',
          '.....dddddd.....',
          '................',
        ],
        CLOTH,
      ),
    },
  },
  {
    // Gola V: a pele aparece no decote em V, com a barra escura do tecido em volta.
    id: 'gola-v',
    name: 'Gola V',
    anchor: 'torso',
    frames: {
      down: sprite(
        [
          '.....xSSSSx.....',
          '......xSSx......',
          '.......xx.......',
          '................',
          '................',
          '................',
          '....dddddddd....',
          '................',
        ],
        CLOTH,
      ),
      up: sprite(
        [
          '.....xxxxxx.....',
          '................',
          '................',
          '................',
          '................',
          '................',
          '....dddddddd....',
          '................',
        ],
        CLOTH,
      ),
      left: sprite(
        [
          '.....xSSx.......',
          '......xx........',
          '................',
          '................',
          '................',
          '................',
          '.....dddddd.....',
          '................',
        ],
        CLOTH,
      ),
    },
  },
  {
    // Polo: gola branca de duas pontas e abotoadura de três botões.
    id: 'polo',
    name: 'Polo',
    anchor: 'torso',
    frames: {
      down: sprite(
        [
          '....xwwSSwwx....',
          '......wxxw......',
          '.......xx.......',
          '.......xx.......',
          '.......ww.......',
          '.......xx.......',
          '....xxxxxxxx....',
          '................',
        ],
        CLOTH,
      ),
      up: sprite(
        [
          '....xxxxxxxx....',
          '................',
          '................',
          '................',
          '................',
          '................',
          '....xxxxxxxx....',
          '................',
        ],
        CLOTH,
      ),
      left: sprite(
        [
          '.....xwwx.......',
          '.....xwx........',
          '................',
          '................',
          '................',
          '................',
          '.....xxxxxx.....',
          '................',
        ],
        CLOTH,
      ),
    },
  },
  {
    // Camisa social: colarinho branco, abotoadura até o meio e barra escura.
    id: 'camisa-social',
    name: 'Camisa social',
    anchor: 'torso',
    frames: {
      down: sprite(
        [
          '....wwSSSSww....',
          '.....wSSSSw.....',
          '......wxxw......',
          '.......xx.......',
          '.......xx.......',
          '.......ww.......',
          '....dddddddd....',
          '................',
        ],
        CLOTH,
      ),
      up: sprite(
        [
          '.....wwwwww.....',
          '................',
          '................',
          '................',
          '................',
          '................',
          '....dddddddd....',
          '................',
        ],
        CLOTH,
      ),
      left: sprite(
        [
          '.....xwlx.......',
          '.....xwx........',
          '................',
          '................',
          '................',
          '................',
          '.....dddddd.....',
          '................',
        ],
        CLOTH,
      ),
    },
  },
  {
    // Xadrez: linhas verticais escuras e horizontais na cor de acento, em grade.
    id: 'xadrez',
    name: 'Xadrez',
    anchor: 'torso',
    frames: {
      down: sprite(
        [
          '.....x...x......',
          '.....x...x......',
          '....aaaaaaaa....',
          '.....x...x......',
          '.....x...x......',
          '....aaaaaaaa....',
          '....dddddddd....',
          '................',
        ],
        CLOTH,
      ),
      up: sprite(
        [
          '.....x...x......',
          '.....x...x......',
          '....aaaaaaaa....',
          '.....x...x......',
          '.....x...x......',
          '....aaaaaaaa....',
          '....dddddddd....',
          '................',
        ],
        CLOTH,
      ),
      left: sprite(
        [
          '.....x...x......',
          '.....x...x......',
          '.....aaaaaa.....',
          '.....x...x......',
          '.....x...x......',
          '.....aaaaaa.....',
          '.....dddddd.....',
          '................',
        ],
        CLOTH,
      ),
    },
  },
  {
    // Moletom: punho e barra em canelado (listras escuras) e bolso canguru.
    id: 'moletom',
    name: 'Moletom',
    anchor: 'torso',
    frames: {
      down: sprite(
        [
          '....xxxxxxxx....',
          '................',
          '................',
          '................',
          '......xxxx......',
          '......x..x......',
          '....xxxxxxxx....',
          '................',
        ],
        CLOTH,
      ),
      up: sprite(
        [
          '....xxxxxxxx....',
          '................',
          '................',
          '................',
          '................',
          '....xdxdxdxd....',
          '....xxxxxxxx....',
          '................',
        ],
        CLOTH,
      ),
      left: sprite(
        [
          '.....xxxxxx.....',
          '................',
          '................',
          '................',
          '................',
          '................',
          '.....xxxxxx.....',
          '................',
        ],
        CLOTH,
      ),
    },
  },
  {
    // Capuz: a gola do capuz em volta do pescoço e dois cordões brancos na frente.
    id: 'capuz',
    name: 'Capuz',
    anchor: 'torso',
    frames: {
      down: sprite(
        [
          '....xxxxxxxx....',
          '....x.w..w.x....',
          '....x.w..w.x....',
          '....x.w..w.x....',
          '....x......x....',
          '....x......x....',
          '....xxxxxxxx....',
          '................',
        ],
        CLOTH,
      ),
      up: sprite(
        [
          '.....xxxxxx.....',
          '....xddddddx....',
          '....xdddxddx....',
          '....xdddxddx....',
          '....xdddxddx....',
          '....xdddxddx....',
          '....xxxxxxxx....',
          '................',
        ],
        CLOTH,
      ),
      left: sprite(
        [
          '.....xxxxxx.....',
          '....xdddddx.....',
          '....xdddddx.....',
          '....xdddddx.....',
          '....xdddddx.....',
          '....xdddddx.....',
          '.....xxxxxx.....',
          '................',
        ],
        CLOTH,
      ),
    },
  },
  {
    // Jaqueta: gola alta, zíper central em metal, bolsos de aba nas laterais e barra escura.
    // De costas: gola alta e uma linha de pala (ombro) cortando o tronco.
    id: 'jaqueta',
    name: 'Jaqueta',
    anchor: 'torso',
    frames: {
      down: sprite(
        [
          '....xxxxxxxx....',
          '....xddMdddx....',
          '....xccMcccx....',
          '....xccMcccx....',
          '....xxcMcxxx....',
          '....xddMdddx....',
          '....xxxxxxxx....',
          '................',
        ],
        CLOTH,
      ),
      up: sprite(
        [
          '....xxxxxxxx....',
          '....xddddddx....',
          '....xccccccx....',
          '....xccccccx....',
          '....xxxxxxxx....',
          '....xccccccx....',
          '....xxxxxxxx....',
          '................',
        ],
        CLOTH,
      ),
      left: sprite(
        [
          '.....xxxxxx.....',
          '.....xdMddx.....',
          '.....xcMccx.....',
          '.....xcMccx.....',
          '.....xxMcxx.....',
          '.....xdMddx.....',
          '.....xxxxxx.....',
          '................',
        ],
        CLOTH,
      ),
    },
  },
  {
    // Blazer: lapelas largas em V (claras), camisa branca no decote, gravata (acc) e bolso
    // no peito. De costas: costura central e barra escura.
    id: 'blazer',
    name: 'Blazer',
    anchor: 'torso',
    frames: {
      down: sprite(
        [
          '....xxwwwwxx....',
          '....xlwwwwlx....',
          '....xllwwllx....',
          '....xlxAAxlx....',
          '....xcxAAxcx....',
          '....xcxaaxdx....',
          '....xxxxxxxx....',
          '................',
        ],
        CLOTH,
      ),
      up: sprite(
        [
          '....xxxxxxxx....',
          '....xccxxccx....',
          '....xccxxccx....',
          '....xccxxccx....',
          '....xccxxccx....',
          '....xddxxddx....',
          '....xxxxxxxx....',
          '................',
        ],
        CLOTH,
      ),
      left: sprite(
        [
          '.....xxxxxx.....',
          '.....xlxccx.....',
          '.....xlxccx.....',
          '.....xlxccx.....',
          '.....xaxccx.....',
          '.....xaxddx.....',
          '.....xxxxxx.....',
          '................',
        ],
        CLOTH,
      ),
    },
  },
  {
    // Colete: sem manga. A camisa branca aparece nas colunas 4 e 11 (faixa que faz o papel
    // da manga que não existe), no decote em V e nos botões. De costas: faixa de ajuste.
    id: 'colete',
    name: 'Colete',
    anchor: 'torso',
    frames: {
      down: sprite(
        [
          '....wxwwwwxw....',
          '....wxcwwcxw....',
          '....wxccccxw....',
          '....wxcgccxw....',
          '....wxccccxw....',
          '....wxcgccxw....',
          '....wxxxxxxw....',
          '................',
        ],
        CLOTH,
      ),
      up: sprite(
        [
          '....wxxxxxxw....',
          '....wccccccw....',
          '....wccccccw....',
          '....wddddddw....',
          '....wgxxxxgw....',
          '....wccccccw....',
          '....wxxxxxxw....',
          '................',
        ],
        CLOTH,
      ),
      left: sprite(
        [
          '.....xxwwxx.....',
          '.....xwcccx.....',
          '.....xwcccx.....',
          '.....xwcccx.....',
          '.....xwgccx.....',
          '.....xwcccx.....',
          '.....xxxxxx.....',
          '................',
        ],
        CLOTH,
      ),
    },
  },
  {
    // Macacão: alças nos ombros, peitilho e calça no mesmo tecido (legs cobre as pernas).
    id: 'macacao',
    name: 'Macacão',
    anchor: 'torso',
    frames: {
      down: sprite(
        [
          '.....x....x.....',
          '.....x....x.....',
          '.....xccccx.....',
          '.....xgccgx.....',
          '.....xccccx.....',
          '.....xddddx.....',
          '....xxxxxxxx....',
          '................',
        ],
        CLOTH,
      ),
      up: sprite(
        [
          '.....x....x.....',
          '.....x....x.....',
          '.....xccccx.....',
          '.....xccccx.....',
          '.....xccccx.....',
          '.....xddddx.....',
          '....xxxxxxxx....',
          '................',
        ],
        CLOTH,
      ),
      left: sprite(
        [
          '......x..x......',
          '......x..x......',
          '......xccx......',
          '......xccx......',
          '......xccx......',
          '......xccx......',
          '.....xxxxxx.....',
          '................',
        ],
        CLOTH,
      ),
    },
    legs: {
      down: sprite(
        [
          '.....xcxxcx.....',
          '.....xcxxcx.....',
          '.....xcxxcx.....',
          '.....xcxxcx.....',
          '................',
          '................',
        ],
        CLOTH,
      ),
      up: sprite(
        [
          '.....xcxxcx.....',
          '.....xcxxcx.....',
          '.....xcxxcx.....',
          '.....xcxxcx.....',
          '................',
          '................',
        ],
        CLOTH,
      ),
      left: sprite(
        [
          '......xccx......',
          '......xccx......',
          '......xccx......',
          '......xccx......',
          '................',
          '................',
        ],
        CLOTH,
      ),
    },
  },
  {
    // Vestido: alças e corpete no tronco; a saia (legs) desce até o joelho.
    id: 'vestido',
    name: 'Vestido',
    anchor: 'torso',
    frames: {
      down: sprite(
        [
          '.....x....x.....',
          '.....x....x.....',
          '.....xccccx.....',
          '.....xccccx.....',
          '.....xccccx.....',
          '.....xccccx.....',
          '....xggggggx....',
          '................',
        ],
        CLOTH,
      ),
      up: sprite(
        [
          '.....x....x.....',
          '.....x....x.....',
          '.....xccccx.....',
          '.....xccccx.....',
          '.....xccccx.....',
          '.....xccccx.....',
          '....xggggggx....',
          '................',
        ],
        CLOTH,
      ),
      left: sprite(
        [
          '......xcx.......',
          '......xcx.......',
          '......xccx......',
          '......xccx......',
          '......xccx......',
          '......xccx......',
          '.....xwwwwx.....',
          '................',
        ],
        CLOTH,
      ),
    },
    legs: {
      down: sprite(
        [
          '.....xccccx.....',
          '....xccccccx....',
          '...xccccccccx...',
          '..xccccccccccx..',
          '................',
          '................',
        ],
        CLOTH,
      ),
      up: sprite(
        [
          '.....xccccx.....',
          '....xccccccx....',
          '...xccccccccx...',
          '..xccccccccccx..',
          '................',
          '................',
        ],
        CLOTH,
      ),
      left: sprite(
        [
          '......xccx......',
          '.....xccccx.....',
          '....xccccccx....',
          '....xccccccx....',
          '................',
          '................',
        ],
        CLOTH,
      ),
    },
  },
  {
    // Regata: sem manga; a pele aparece nas cavas e só duas alças cruzam o peito.
    id: 'regata',
    name: 'Regata',
    anchor: 'torso',
    frames: {
      down: sprite(
        [
          '....SxxxxxxS....',
          '....Sx....xS....',
          '.....x....x.....',
          '.....x....x.....',
          '................',
          '................',
          '................',
          '................',
        ],
        CLOTH,
      ),
      up: sprite(
        [
          '....SxxxxxxS....',
          '....Sx....xS....',
          '.....x....x.....',
          '.....x....x.....',
          '................',
          '................',
          '................',
          '................',
        ],
        CLOTH,
      ),
      left: sprite(
        [
          '......xx........',
          '.....Sx.........',
          '.....Sx.........',
          '................',
          '................',
          '................',
          '................',
          '................',
        ],
        CLOTH,
      ),
    },
  },
  {
    // Jaleco: branco, lapelas com abertura central e barra escura. legs é a parte da saia do jaleco.
    id: 'jaleco',
    name: 'Jaleco',
    anchor: 'torso',
    frames: {
      down: sprite(
        [
          '....xwwxxwwx....',
          '.....xwxxwx.....',
          '......wxxw......',
          '......wxxw......',
          '.....wwxxww.....',
          '.....wwxxww.....',
          '....xxxxxxxx....',
          '................',
        ],
        CLOTH,
      ),
      up: sprite(
        [
          '....xxxxxxxx....',
          '.....wwwwww.....',
          '.....wwwwww.....',
          '.....wwwwww.....',
          '.....wwwwww.....',
          '.....wwwwww.....',
          '....xxxxxxxx....',
          '................',
        ],
        CLOTH,
      ),
      left: sprite(
        [
          '.....xwwx.......',
          '.....xwwwx......',
          '.....xwwwx......',
          '.....xwwwx......',
          '.....xwwwx......',
          '.....xwwwx......',
          '.....xxxxxx.....',
          '................',
        ],
        CLOTH,
      ),
    },
    legs: {
      down: sprite(
        [
          '....xwwxxwwx....',
          '....xwwxxwwx....',
          '....xwwxxwwx....',
          '....xxxxxxxx....',
          '................',
          '................',
        ],
        CLOTH,
      ),
      up: sprite(
        [
          '....xwwwwwwx....',
          '....xwwwwwwx....',
          '....xwwwwwwx....',
          '....xxxxxxxx....',
          '................',
          '................',
        ],
        CLOTH,
      ),
      left: sprite(
        [
          '.....xwwwwx.....',
          '.....xwwwwx.....',
          '.....xwwwwx.....',
          '.....xxxxxx.....',
          '................',
          '................',
        ],
        CLOTH,
      ),
    },
  },
];
